import styled from "styled-components";

export const StyledBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${(props) => `${props.theme.spacing[24]}`};
`;

export const StyledTitleWrapper = styled.div`
    text-align: center;
    width: 100%;
`;

export const StyledTitleSubtitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${(props) => `${props.theme.spacing[8]}`};
`;

export const StyledButtons = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: ${(props) => `${props.theme.spacing[16]}`};
`;
